module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-ebook-thumbnail-1a7250370a99c16d8ce481de5d0e8d73.png";